<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#stop3"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title text-color-red2">Удаление невозможно</div>

              <p class="info-text">
                  Перед удалением папки переместите<br>
                  или удалите из неё все вложенные элементы.
              </p>
          </div>

          <div class="mt24">
              <span class="btn btn--ico" @click="close">Понятно</span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "RemoveCatError",
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.removeCatError.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
            }),
        }
    }
</script>

<style scoped>

</style>
